
import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'PaymentResult',
})
export default class PaymentResult extends Vue {
  get isSuccess(): boolean {
    return this.$route.query.success === 'true';
  }

  get amount(): number {
    return Number(this.$route.query.amount) || 0;
  }

  get message(): string {
    const msg = this.$route.query.message as string;
    try {
      return msg ? decodeURIComponent(msg) : '';
    } catch {
      return msg || '';
    }
  }

  private formatCurrency(value: number): string {
    return value.toLocaleString('ko-KR');
  }
}
